import React, { CSSProperties } from "react";
import { styled } from "@mui/material/styles";
import TextField, { FilledTextFieldProps } from "@mui/material/TextField";

interface StyledTextFieldProps {
  inputProps?: any;
  onChange: (e: any) => void;
  margin?: "none" | "dense" | "normal";
  fullWidth: boolean;
  autoFocus: boolean;
  HTMLInputType?: string;
  label: string;
  disabled?: boolean;
  defaultValue?: string;
  color?: string;
  style?: CSSProperties;
}

interface MUIStyledTextFieldProps extends FilledTextFieldProps {
  highlightsColor: string;
}

const MUIStyledTextField = styled(TextField, {
  shouldForwardProp: (prop) => prop !== "highlightsColor",
})<MUIStyledTextFieldProps>(({ theme, highlightsColor }) => ({
  "& .MuiFilledInput-root": {
    color: `${highlightsColor} !important`,
  },
  "& label": {
    color: highlightsColor,
    opacity: 0.5,
  },
  "& label.Mui-focused": {
    color: highlightsColor,
    opacity: 1,
  },
  "& .MuiFilledInput-underline:before": {
    borderBottomColor: highlightsColor,
  },
  "& .MuiFilledInput-underline:hover:before": {
    borderBottomColor: highlightsColor,
  },
  "& .MuiFilledInput-underline:after": {
    borderBottomColor: highlightsColor,
  },
}));

const StyledTextField = ({
  inputProps = {},
  onChange,
  margin,
  fullWidth,
  autoFocus,
  HTMLInputType = "text",
  label,
  disabled = false,
  defaultValue = "",
  color = "#fff",
  style = {},
}: StyledTextFieldProps) => {
  return (
    <MUIStyledTextField
      inputProps={inputProps}
      onChange={onChange}
      margin={margin}
      fullWidth={fullWidth}
      autoFocus={autoFocus}
      type={HTMLInputType}
      variant="filled"
      label={label}
      defaultValue={defaultValue}
      disabled={disabled}
      highlightsColor={color}
      style={style}
    />
  );
};

export default StyledTextField;
